import { useDispatch, useSelector } from 'react-redux';
import React, { useRef, useEffect } from 'react';
import clsx from 'clsx';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import Model from './Model';
import { inventoryResultSelector, defaultZipCodeSelector } from '../store/inventory-near-you/selector';
import { fetchDealerAsync } from '../store/inventory-near-you/reducer';
import { MAPPING } from '../helpers';
import { CLICK_EVENT_ACTION_TYPE, CLICK_EVENT_TRIGGER, UI_CONTROLS_ACTION_CATEGORY } from '../../../../constants';
import { MODULE_NAME } from '../helpers/constant';

const { arrowNext, arrowPrev, models } = MAPPING;

const ListModels = () => {
  const paginationRef = useRef(null);
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  const defaultZipCode = useSelector(defaultZipCodeSelector);
  const inventoryResult = useSelector(inventoryResultSelector);
  const inventoryModels = inventoryResult?.Models ? inventoryResult.Models : [];
  const inventoryDealers = inventoryResult?.Dealers ? inventoryResult.Dealers : [];

  // bind models & dealers to renderingModels
  const renderingModels = inventoryModels.map((invModel) => {
    const dealer = inventoryDealers.find((invDealer) => invDealer.DID === invModel.DID);
    const model = models.find((item) => item.ModelID === invModel.MID);
    return {
      ...invModel,
      model,
      dealer,
    };
  });

  const dispatch = useDispatch();

  const removeAriaDisabled = () => {
    // remove attr aria-disabled
    if (navigationNextRef.current && navigationPrevRef.current) {
      navigationNextRef.current.removeAttribute('aria-disabled');
      navigationPrevRef.current.removeAttribute('aria-disabled');
    }
  };

  useEffect(() => {
    if (defaultZipCode) {
      const modelsId = Array.isArray(models) ? models.map((model) => model.ModelID).join(',') : '';
      dispatch(fetchDealerAsync({ zip: defaultZipCode, ModelID: modelsId }));
    }
  }, [dispatch, defaultZipCode]);

  return (
    <div className={clsx('list-models relative lg:pb-30', renderingModels.length ? '' : 'hidden')}>
      <Swiper
        className="swiper-container -mx-2 md:-mx-4 md:mb-12 xl:mb-0"
        modules={[Navigation, Pagination, Scrollbar, A11y]}
        speed={500}
        slidesPerView={1}
        breakpoints={
          {
            768: {
              slidesPerView: 2,
            },
            1200: {
              slidesPerView: 3,
            },
          }
        }
        pagination={{
          el: paginationRef.current,
          type: 'progressbar',
          clickable: true,
        }}
        navigation={{
          prevEl: navigationPrevRef.current,
          nextEl: navigationNextRef.current,
        }}
        onInit={(swiper) => {
          swiper.params.navigation.prevEl = navigationPrevRef.current;
          swiper.params.navigation.nextEl = navigationNextRef.current;
          swiper.navigation.init();
          swiper.navigation.update();
          removeAriaDisabled();
        }}
        onTransitionEnd={() => {
          removeAriaDisabled();
        }}
      >
        {renderingModels.map((model, index) => (
          <SwiperSlide key={model.MID.concat(model.DID).concat(model.MY).concat(model.MCCD)} >
            <Model model={model} index={index} />
          </SwiperSlide>
        ))}
      </Swiper>
      <div ref={paginationRef} className="swiper-pagination swiper-pagination-relative xl:hidden" />
      <div className="hidden lg:block">
        <button ref={navigationPrevRef} type="button" className="swiper-button swiper-button-prev text-h5-md transform-middle rounded-full bg-white transition-0p6 lg:w-32 lg:h-32 lg:-mt-2 lg:-left-15 2xl:-left-32 1k6:-left-24 delay-ins-6"
          data-event-trigger={CLICK_EVENT_TRIGGER} data-event-type={CLICK_EVENT_ACTION_TYPE} data-event-module={MODULE_NAME} data-event-label="prev slide" data-event-category={UI_CONTROLS_ACTION_CATEGORY}
        >
          <span className="icomoon icon-arrow-left text-black" aria-hidden="true" />
          <span className="sr-only">{arrowPrev}</span>
        </button>

        <button ref={navigationNextRef} type="button" className="swiper-button swiper-button-next text-h5-md transform-middle rounded-full bg-white transition-0p6 lg:w-32 lg:h-32 lg:-mt-2 lg:-right-15 2xl:-right-32 1k6:-right-24 delay-ins-6"
          data-event-trigger={CLICK_EVENT_TRIGGER} data-event-type={CLICK_EVENT_ACTION_TYPE} data-event-module={MODULE_NAME} data-event-label="next slide" data-event-category={UI_CONTROLS_ACTION_CATEGORY}
        >
          <span className="icomoon icon-arrow-right text-black" aria-hidden="true" />
          <span className="sr-only">{arrowNext}</span>
        </button>
      </div>
    </div>

  );
};
export default ListModels;